// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8add630e","455":"acb7ad08"}[chunkId] + ".chunk.js";
};